const theme = {
  fontFamily: "Roboto, Arial, sans-serif",
  colors: {
    mainBgColor: "#141414",
    mainDark: "rgb(0, 0, 0)",
  },
  skeleton: {
    backgroundColor: "#141414",
    filter: "brightness(140%)",
  },
  sliderTitle: {
    color: "#e5e5e5",
    fontSize: "24px",
    fontWeight: "600",
  },
  image: {
    aspectRatio: "4 / 3",
    borderRadius: "6px",
  },
  sliderItemLabel: {
    color: "#fff",
    fontWeight: 600,
  },
  moreBtn: {
    borderRadius: "18px",
    boxSizing: "border-box",
    padding: "8px 30px 8px 30px",
    border: "1px solid white",
    color: "#fff",
    fontWeight: "500",
    fontSize: "14px",
    outline: "none",
    cursor: "pointer",
    textDecoration: "none",
  },
  moreBtnHover: {
    color: "#00ae42",
  },
  sliderHeader: {
    margin: "20px 65px",
  },
  sliderHeaderSmall: {
    margin: "20px 35px",
  },
  sliderHeaderMobile: {
    margin: " 16px 10px",
  },
  playBtnHighlights: {
    color: "#00ae42",
  },
  slideBtn: {
    backgroundColor: "rgba(0, 0, 0, 0.7)", // always use rgba with opacity 0.7 here
    color: "#fff",
  },
  toggleSmartSearch: {
    borderColor: "#8a8c92",
    color: "rgb(182, 188, 198)",
    margin: "20px 65px",
  },
  toggleSmartSearchMobile: {
    margin: "20px 10px",
  },
  toggleSmartSearchHover: {
    borderColor: "rgb(224 228 234 / 1)",
  },
};

export default theme;
